import type { User } from '@/api'
import type { GroupWithUserData } from './types'

function collectMembersFromGroup(group: GroupWithUserData): User[] {
  const members = group.membersDetails ?? []
  const childrenMembers = (group.children ?? []).flatMap(collectMembersFromGroup)
  return [...members, ...childrenMembers]
}

function dedupeUsersByUid(users: User[]): User[] {
  return Array.from(
    new Map(
      users.filter((u) => u.uid).map((u) => [u.uid!, u])
    ).values()
  )
}

export function collectGroupMembers(group: GroupWithUserData): User[] {
  return dedupeUsersByUid(collectMembersFromGroup(group))
}

export function collectAllGroupMembers(groups: GroupWithUserData[]): User[] {
  return dedupeUsersByUid(groups.flatMap(collectMembersFromGroup))
}
